module.exports = __webpack_public_path__ + "img/default.17704216.png";